// External libraries
import { useSetRecoilState, useRecoilState, useResetRecoilState } from 'recoil';
import { useNavigate, useLocation } from 'react-router-dom';

// Components
import { authState, loggedUserState, usersState, spinnerState, overlayState, userCurrencyState, geoJsonState, geoJSONProps, popoverState, errorState, geoState, cifTypeState, checkboxState, CIFType, prevCifTypeState, metricState, selectedTabState, recommendedRegionsState, selectedCategoryState, selecteddropDownDataState, selecteddropDownDataLocationState, filtersState, filterDefaultState, hoveredBrandState, focusedPoiState, expandedPresenceConfigState, selectedGeoNameState, poiVisibleState, selectedCardState, expandedHeaderBreakdownTableState, selectedBreakDownState, selectedBreakDownIndexState, selectedDashboardStackRankKeysState, selectedChilddashboardState, kpiValuesLoadedState, buttonStateRetainedState, breakdownTableSortState, showMapColorState, showDrawerState, selectedYearState, overlayCountState, AllSettingsState, UserSettingsState, selPOICategories, selectedBrands, POICategories, brandList, poiMapColorState } from '../states';

// Utilities
import { APIS, INVITE_TABLE_HEADER, InviteTableHeader, RouteConstants } from '../constants';
import { generateHSL, initialGenerator, useFetchWrapper, useHandleError } from '../helpers';
import { openCarouselState } from '../states/CarouselState';


const useUserService = () => {
    const fetchWrapper = useFetchWrapper();
    const location = useLocation();
    const navigate = useNavigate();
    const [auth, setAuth] = useRecoilState(authState);
    const setUserCurrency = useSetRecoilState(userCurrencyState);
    const setOverlay = useSetRecoilState(overlayState);
    const setPopover = useSetRecoilState(popoverState);
    const setLoggedUser = useSetRecoilState(loggedUserState);
    const setUsers = useSetRecoilState(usersState);
    const setSpinner = useSetRecoilState(spinnerState);
    const setError = useSetRecoilState(errorState);
    const setGeoJSON = useSetRecoilState(geoJsonState);;
    const setselectedGeo = useSetRecoilState(geoState);
    const setOpenCarousel = useSetRecoilState(openCarouselState);
    const setCifType = useSetRecoilState(cifTypeState);
    const setPrev = useSetRecoilState(prevCifTypeState);
    const setIsChecked = useSetRecoilState(checkboxState);
    const setSelMetric = useSetRecoilState(metricState);
    const { getErrorMsg } = useHandleError();
    const setSelectedTab = useSetRecoilState(selectedTabState);
    const setRecommendedRegionsPayload = useSetRecoilState(recommendedRegionsState);

    // Reset hooks for clearing all states on logout
    const resetLoggedUser = useResetRecoilState(loggedUserState);
    const resetUsers = useResetRecoilState(usersState);
    const resetOverlay = useResetRecoilState(overlayState);
    const resetPopover = useResetRecoilState(popoverState);
    const resetError = useResetRecoilState(errorState);
    const resetOpenCarousel = useResetRecoilState(openCarouselState);
    const resetSelectedCategory = useResetRecoilState(selectedCategoryState);
    const resetDropDownData = useResetRecoilState(selecteddropDownDataState);
    const resetDropDownDataLocation = useResetRecoilState(selecteddropDownDataLocationState);
    const resetFilters = useResetRecoilState(filtersState);
    const resetFilterDefault = useResetRecoilState(filterDefaultState);
    const resetHoveredBrand = useResetRecoilState(hoveredBrandState);
    const resetFocusedPoi = useResetRecoilState(focusedPoiState);
    const resetExpandedPresenceConfig = useResetRecoilState(expandedPresenceConfigState);
    const resetSelectedGeoName = useResetRecoilState(selectedGeoNameState);
    const resetPoiVisible = useResetRecoilState(poiVisibleState);
    const resetSelectedCard = useResetRecoilState(selectedCardState);
    const resetExpandedHeaderBreakdownTable = useResetRecoilState(expandedHeaderBreakdownTableState);
    const resetSelectedBreakDown = useResetRecoilState(selectedBreakDownState);
    const resetSelectedBreakDownIndex = useResetRecoilState(selectedBreakDownIndexState);
    const resetSelectedDashboardStackRankKeys = useResetRecoilState(selectedDashboardStackRankKeysState);
    const resetSelectedChilddashboard = useResetRecoilState(selectedChilddashboardState);
    const resetKpiValuesLoaded = useResetRecoilState(kpiValuesLoadedState);
    const resetButtonStateRetained = useResetRecoilState(buttonStateRetainedState);
    const resetBreakdownTableSort = useResetRecoilState(breakdownTableSortState);
    const resetShowMapColor = useResetRecoilState(showMapColorState);
    const resetShowDrawer = useResetRecoilState(showDrawerState);
    const resetSelectedYear = useResetRecoilState(selectedYearState);
    const resetOverlayCount = useResetRecoilState(overlayCountState);
    const resetAllSettings = useResetRecoilState(AllSettingsState);
    const resetUserSettings = useResetRecoilState(UserSettingsState);
    const resetSelPOICategories = useResetRecoilState(selPOICategories);
    const resetSelectedBrands = useResetRecoilState(selectedBrands);
    const resetPOICategories = useResetRecoilState(POICategories);
    const resetBrandList = useResetRecoilState(brandList);
    const resetPoiMapColor = useResetRecoilState(poiMapColorState);

    const login = async (data: any) => {
        // setPopover('Click here for a comparison of different regions within this location.');
        setSpinner(prev => ({ ...prev, spinners: [...prev.spinners, 'login'] }));
        localStorage.removeItem('user');
        return fetchWrapper.post(APIS.USERS.LOGIN, data)
            .then(async (user) => {
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem("currency", user?.currency);
                localStorage.setItem("map-style", user?.map_style || 'roadmap');
                localStorage.setItem("poimarker","true")
                // localStorage.setItem('email_id', data.email_id);
                setAuth(user);
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                setUserCurrency(user?.currency);
                setSpinner(prev => ({ ...prev, spinners: prev.spinners.filter(s => s !== 'login') }));
                getUserDetails().then((response: any) => {
                    localStorage?.setItem('selectedTab', response?.sublevel == "subdistrict" ? "4" : "5")
                    response?.sublevel === 'subdistrict' ? setSelectedTab(4) : setSelectedTab(5);
                    // get return url from location state or default to home page
                    // const from = (!location.pathname || location.pathname === '/login') ? RouteConstants.root : location.pathname;
                    if (user.is_first_login) {
                        setPopover('Click here for a comparison of different regions within this location.');
                        setOverlay(true);
                        acceptAgreement();
                        // setOpenCarousel(true);
                    }
                    navigate({
                        pathname: RouteConstants.root,
                        search: '?country=1',
                    });
                });
            })
            .catch(error => {
                setSpinner(prev => ({ ...prev, spinners: prev.spinners.filter(s => s !== 'login') }));
                // getErrorMsg(error);
                setError({ type: 'Error', message: error?.response?.data?.detail });
            });

    }

    const logout = () => {
        setSpinner(prev => ({ ...prev, spinners: [...prev.spinners, 'logout'] }));
        const refresh = auth?.tokens?.refresh;
        return fetchWrapper.post(APIS.USERS.LOGOUT, { refresh })
            .then(response => {
                // Clear all localStorage
                localStorage.clear();

                // Reset all Recoil states to their default values
                setAuth({});
                setCifType([]);
                setPrev([]);
                setSelectedTab(4);
                setUserCurrency('');
                setselectedGeo({ country: '1' });
                setGeoJSON({} as geoJSONProps);
                setRecommendedRegionsPayload(null);

                // Reset additional states
                resetLoggedUser();
                resetUsers();
                resetOverlay();
                resetPopover();
                resetError();
                resetOpenCarousel();
                resetSelectedCategory();
                resetDropDownData();
                resetDropDownDataLocation();
                resetFilters();
                resetFilterDefault();
                resetHoveredBrand();
                resetFocusedPoi();
                resetExpandedPresenceConfig();
                resetSelectedGeoName();
                resetPoiVisible();
                resetSelectedCard();
                resetExpandedHeaderBreakdownTable();
                resetSelectedBreakDown();
                resetSelectedBreakDownIndex();
                resetSelectedDashboardStackRankKeys();
                resetSelectedChilddashboard();
                resetKpiValuesLoaded();
                resetButtonStateRetained();
                resetBreakdownTableSort();
                resetShowMapColor();
                resetShowDrawer();
                resetSelectedYear();
                resetOverlayCount();
                resetAllSettings();
                resetUserSettings();
                resetSelPOICategories();
                resetSelectedBrands();
                resetPOICategories();
                resetBrandList();
                resetPoiMapColor();

                setSpinner(prev => ({ ...prev, spinners: prev.spinners.filter(s => s !== 'logout') }));
                navigate(RouteConstants.login);
                document.title = 'EPIC Intelligence'
            })
            .catch(error => {
                setSpinner(prev => ({ ...prev, spinners: prev.spinners.filter(s => s !== 'logout') }));
                getErrorMsg(error);
            });

    }

    const getAll = () => {
        setSpinner(prev => ({ ...prev, spinners: [...prev.spinners, 'getAll'] }));
        return fetchWrapper.get(APIS.USERS.GET_ALL_USERS).then(response => {
            // setUsers(response);
            handleSortTable(response, INVITE_TABLE_HEADER[0], 'desc', 0);
            setSpinner(prev => ({ ...prev, spinners: prev.spinners.filter(s => s !== 'getAll') }));
        }).catch(error => {
            setSpinner(prev => ({ ...prev, spinners: prev.spinners.filter(s => s !== 'getAll') }));
            getErrorMsg(error);
        })
    };

    const getUserDetails = async () => {
        setSpinner(prev => ({ ...prev, spinners: [...prev.spinners, 'getUserDetails'] }));
        return fetchWrapper.get(APIS.USERS.GET_LOGGED_USER).then(data => {
            localStorage.setItem('user_id', data.user_id);
            localStorage.setItem('email_id', data.email_id);
            const selectedtoggles: CIFType[] = JSON.parse(localStorage?.getItem("selectedtoggles")!);
            const selMetrics = JSON.parse(localStorage?.getItem("selMetrics") || '{}');
            const initial = initialGenerator(data.name);
            const userHSL = generateHSL(data.name);

            // Flatten the new data structure (with mapping and items) to create configMap
            // Handles both old flat array structure and new nested structure with mapping/items
            const configMap = Object.fromEntries(
                data.default_config.flatMap((group: any) => {
                    // If group has 'items' property, it's the new nested structure
                    if (group.items && Array.isArray(group.items)) {
                        return group.items.map((item: any) => [item.type, item]);
                    }
                    // Otherwise, it's the old flat structure
                    return [[group.type, group]];
                })
            );
            const metricTypes: CIFType[] = ['EH', 'CTV', 'PoI'];

            setLoggedUser({ ...data, initial, userHSL });

            // Handle poimarker: check localStorage first, if not set, use default true and set it
            const poimarkerFromStorage = localStorage.getItem("poimarker");
            const poimarkerValue = poimarkerFromStorage !== null
                ? JSON.parse(poimarkerFromStorage)
                : (configMap.poimarker?.isselected ?? true);

            if (poimarkerFromStorage === null) {
                localStorage.setItem("poimarker", "true");
            }

            setIsChecked({
                MBP: configMap.MBP?.isselected || false,
                spotlight: configMap.spotlight?.isselected || false,
                poimarker: poimarkerValue,
                adjacency: JSON.parse(localStorage.getItem("adjacency")!) || configMap.adjacency?.isselected || false,
                subregionBoundaries: configMap.subregionBoundaries?.isselected || false,
                catchments: JSON.parse(localStorage.getItem("catchments")!) || configMap.catchments?.isselected || false,
            });

            let newCifTypePrev = Array.isArray(selectedtoggles) ? selectedtoggles : metricTypes.filter(type => configMap[type]?.isselected) as CIFType[];

            localStorage?.setItem("selectedtoggles", JSON.stringify(newCifTypePrev));

            setCifType(newCifTypePrev);
            setPrev(newCifTypePrev);

            setSelMetric(prev => {
                if (Object.keys(selMetrics)?.length > 0) {
                    localStorage.setItem("selMetrics", JSON.stringify(selMetrics));
                    return selMetrics;
                } else {
                    const newSelMetric = metricTypes.reduce((acc: any, type) => {
                        const options = configMap[type]?.options[0]!;
                        return ({
                            ...acc,
                            [type]: options ? { ...options, isRank: configMap[type]?.isselected } : null
                        });
                    }, {} as { EH: any; CTV: any; PoI: any });
                    localStorage.setItem("selMetrics", JSON.stringify(newSelMetric));
                    return newSelMetric;
                }
            });

            setSpinner(prev => ({ ...prev, spinners: prev.spinners.filter(s => s !== 'getUserDetails') }));

            return data;
        })
            .catch(error => {
                setSpinner(prev => ({ ...prev, spinners: prev.spinners.filter(s => s !== 'getUserDetails') }));
                getErrorMsg(error);
            });
    };

    const updateUserDetails = (updatedData: any) => {
        return fetchWrapper.put(APIS.USERS.UPDATE_LOGGED_USER, updatedData);
    }

    const updateUserImage = (image: any) => {
        return fetchWrapper.put(APIS.USERS.UPDATE_IMAGE, image);
    }

    const setNewPassword = (data: any) => {
        return fetchWrapper.post(APIS.USERS.SET_NEW_PASSWORD, data);
    }

    const validateToken = (data: any) => {
        return fetchWrapper.get(APIS.USERS.VALIDATE_TOKEN, data);
    }

    const changePassword = (data: any) => {
        return fetchWrapper.put(APIS.USERS.CHANGE_PASSWORD, data);
    }

    const forgotPassword = (data: any) => {
        return fetchWrapper.post(APIS.USERS.FORGOT_PASSWORD, data);
    }

    const requestInvite = (newUser: any) => {
        return fetchWrapper.post(APIS.USERS.USER_INVITE, newUser)
    }

    const adminInvite = (newUser: any) => {
        return fetchWrapper.post(APIS.USERS.ADMIN_INVITE, newUser)
    }

    const editInvite = (updatedUser: any) => {
        var api = APIS.USERS.EDIT_INVITE + updatedUser.user_id + '/details/'; // update invite by user with 3 values 
        // var api = APIS.USERS.EDIT_USER + updatedUser.user_id + '/'; // update invite by admin with 5 values
        return fetchWrapper.put(api, updatedUser);
    }

    const acceptAgreement = () => {
        return fetchWrapper.get(APIS.USERS.ACCEPT_AGREEMENT);
    }

    const deleteInvite = (user_id: string) => {
        const URL = APIS.USERS.DELETE_INVITE + user_id + '/delete/';
        // const URL = APIS.USERS.DELETE_USER + user_id + '/';
        return fetchWrapper.delete(URL);
    }
    // function for sorting
    const handleSortTable = (users: any, item: InviteTableHeader, order: string, index: number) => {
        let sortedTable = users.slice().sort((a: any, b: any) => {
            const actualKey = item.key + 'ActualValue';
            const hasActualValue = users.some((obj: any) => obj.hasOwnProperty(actualKey));
            if (a[item.key] === null && b[item.key] === null) {
                return 0;
            } else if (a[item.key] === null) {
                return 1;
            } else if (b[item.key] === null) {
                return -1;
            } else if (typeof a[item.key] === 'string' && typeof b[item.key] === 'string') {
                if (hasActualValue) {
                    return order === 'desc' ? a[actualKey] - b[actualKey] : b[actualKey] - a[actualKey];
                }
                return order === 'desc' ? a[item.key].localeCompare(b[item.key]) : b[item.key].localeCompare(a[item.key]);
            } else if (typeof a[item.key] === 'number' && typeof b[item.key] === 'number') {
                if (hasActualValue) {
                    return order === 'desc' ? a[actualKey] - b[actualKey] : b[actualKey] - a[actualKey];
                }
                return order === 'desc' ? b[item.key] - a[item.key] : a[item.key] - b[item.key];
            } else {
                return 0;
            }
        });
        setUsers([...sortedTable])
    }

    return {
        login,
        logout,
        getAll,
        getUserDetails,
        updateUserDetails,
        updateUserImage,
        changePassword,
        forgotPassword,
        setNewPassword,
        validateToken,
        requestInvite,
        adminInvite,
        editInvite,
        acceptAgreement,
        deleteInvite,
    }
}

export { useUserService };


